import { styled } from '@linaria/react';
const typeIconClass = "tz6gqh2";
const EmptyStateAnnouncer = /*#__PURE__*/styled('div')({
  name: "EmptyStateAnnouncer",
  class: "e1acyjxe",
  propsAsIs: false
});

/* limit description to 2 lines */
const lineLimitClass = "lvs0cz1";
const ChildrenWrapper = /*#__PURE__*/styled('div')({
  name: "ChildrenWrapper",
  class: "c1drjxke",
  propsAsIs: false
});
const StyledAnnouncer = /*#__PURE__*/styled('div')({
  name: "StyledAnnouncer",
  class: "soudhsx",
  propsAsIs: false
});
const ExpandButton = /*#__PURE__*/styled('button')({
  name: "ExpandButton",
  class: "eydrhtr",
  propsAsIs: false
});
const ActionButton = /*#__PURE__*/styled('button')({
  name: "ActionButton",
  class: "a1k65rw",
  propsAsIs: false
});
const CloseButton = /*#__PURE__*/styled('button')({
  name: "CloseButton",
  class: "c1tg0h1g",
  propsAsIs: false
});
export { typeIconClass, EmptyStateAnnouncer, StyledAnnouncer, lineLimitClass, ExpandButton, ActionButton, CloseButton, ChildrenWrapper };

require("./Announcer.styles.linaria.module.css!=!../../../../../@linaria+webpack5-loader@4.1.17_webpack@5.95.0/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./Announcer.styles.js");